import React, { Component } from "react";
import CartContext from "./CartContext";
import { Carousel, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Showcase } from "./Showcase";
import { DemoLinks } from "./Home";
import {
  AccountingModule,
  CommonModules,
  CouponsManagementModule,
  CrmModule,
  DeliveryManagementModule,
  ECommerceB2BModule,
  ECommerceB2CModule,
  ErpRetail,
  HrmModule,
  InventoryModule,
  LeadsManagementModule,
  OrdersManagementModule,
  PackagingManagementModule,
  RetailPosModule,
  ProductionModule,
  ProductServiceModule,
  PurchasesModule,
  QuoteManagementModule,
  RawMaterialsModule,
  ReportsModule,
} from "./CommonModules";
import { ECommerceFeatures, ECommercePricing } from "./Pricing";
import { DigitalMarketingPricing } from "./Pricing";

export class ECommerceB2B extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      stores: [
        {
          name: "product_ecommerce_b2b.png",
          title: "Bags Manufacturing",
          url: "https://bagfactory.elasticcart.com",
        },
      ],
    };
  }

  handleSelect = (selectedIndex) => {
    this.setState({ index: selectedIndex });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <div className="container-fluid py-5 bg-white">
        <div className="container">
          <div className="row gx-5">
            <div className="col-12 border-start border-5 border-primary ps-3 mb-lg-1">
              <h6 className="text-primary text-uppercase">
                Product & Features
              </h6>
              <h2 className="display-6 text-dark">
                E-Commerce B2B / Sales and Leads Generation Platform
              </h2>
            </div>
          </div>
          <p className="text-muted lead">
            E-Commerce B2B is a powerful platform designed to help businesses
            generate leads and sales through online channels. With its advanced
            features and user-friendly interface, it enables businesses to
            create and manage leads, generate quotes, track customer behavior,
            collect payments and optimize their marketing strategies for maximum
            impact.
          </p>

          <div className="col-lg-12 mb-lg-5">
            <video
              controls
              height="400px"
              autoPlay
              muted
              loop
              width="100%"
              // className="rounded shadow"
              aria-label="POS software demo video"
            >
              <source
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "EComerceB2bVideo.mp4"
                }
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="row g-4">
            <div className="col-12 col-lg-8 text-center">
              <h1> Modal Business Sites</h1>
              <Carousel
                fade
                activeIndex={this.state.index}
                onSelect={this.handleSelect}
              >
                {this.state.stores.map((store, idx) => (
                  <Carousel.Item key={idx} interval={3000}>
                    <div className="bg-white border CornersRoundedBig p-4 text-center">
                      <h3 className="text-dark mb-3">{store.title}</h3>
                      <a
                        href={store.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`https://ecprdstorage01.blob.core.windows.net/elasticcart/images/${store.name}`}
                          alt={store.title}
                          className="img-fluid rounded"
                          style={{ maxHeight: "400px", objectFit: "contain" }}
                        />
                      </a>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            <div className="col-12 col-lg-4">
              <div className="bg-light p-4 rounded h-100">
                <Button
                  as={Link}
                  variant="warning"
                  className="w-100"
                  to="/Checkout"
                  onClick={() => {
                    if (this.context.userData.loginStatus !== "active") {
                      this.context.ShowUserLoginNew(true);
                    }
                    this.context.SetSelectedProduct(
                      this.context.prods.find(
                        (f) =>
                          f.productType ===
                          this.context.ProductType.ECommerce_B2B
                      )
                    );
                  }}
                >
                  Try Free / Buy
                </Button>
                <h5 className="text-dark mb-3">Key Features</h5>
                <ul className="list-unstyled small text-muted">
                  <li>✔ Free SSL and Custom domain</li>
                  <li>✔ Premium & Custom Themes</li>
                  <li>✔ OTP Authentication (SMS/Email)</li>
                  <li>✔ Payment Gateway, COD, Manual UPI</li>
                  <li>✔ Product Variants, Multi-Image, Video</li>
                  <li>✔ Discounts, Wishlists, Smart Cart</li>
                  <li>✔ Customer recently visited products</li>
                  <li>✔ Product Bundles, Gift Cards</li>
                  <li>✔ Vlogs & Blogs Integration</li>
                  <li>✔ Marketing ads, SEO, and Social Media</li>
                  <li>✔ Notifications: Email, WhatsApp, Abandoned Cart</li>
                  <li>✔ Multi-Store, Multi-Vendor, Multi-Currency</li>
                  <li>✔ Multi-Language, Multi-Location</li>
                  <li>✔ Product Reviews, Ratings, and Comments</li>
                  <li>✔ Customer Groups, Memberships, and Subscriptions</li>
                  <li>✔ Analytics, Reports, Customer Dashboard</li>
                </ul>
              </div>
            </div>
          </div>

          {/* ERP Modules Section */}
          <section className="container my-5">
            <h1 className="text-dark mb-4">
              Explore Integrated ERP Modules That Power Your Business
            </h1>
            <Row className="g-3">
              {[
                ECommerceB2BModule,
                LeadsManagementModule,
                QuoteManagementModule,
                ProductionModule,
                ProductServiceModule,
                InventoryModule,
                PurchasesModule,
                RawMaterialsModule,
                OrdersManagementModule,
                PackagingManagementModule,
                DeliveryManagementModule,
                CrmModule,
                CouponsManagementModule,
                HrmModule,
                AccountingModule,
                ReportsModule,
              ].map((Module, index) => (
                <Col md={6} lg={6} key={index}>
                  <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                    <Module />
                  </div>
                </Col>
              ))}
            </Row>
          </section>
        </div>
      </div>
    );
  }
}
